export const msalConfig = {
    auth: {
      clientId: "16f534cf-03c9-479f-bf95-11ea24690978",
      authority: "https://naaproxy.b2clogin.com/naaproxy.onmicrosoft.com/B2C_1_SignIn/",
      knownAuthorities: ["naaproxy.b2clogin.com"],
      redirectUri: "https://smartpos.netsfuturepayments.eu",
      postLogoutRedirectUri: "https://smartpos.netsfuturepayments.eu/logout/"
    }
  }

  export const loginRequest = {
  }
